import axios from 'axios';

const API_KEY = '35c15e1a48b2359e481b72ba6988b80e'; // Sustituye con tu clave
const BASE_URL = 'https://api.themoviedb.org/3';

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  params: {
    api_key: API_KEY,
  },
});

export default axiosInstance;
